import React, { useMemo } from 'react';
import { Segmented } from 'antd';
import { CustomSVG } from '../CustomSVG/CustomSVG';
import ViewModeHiddenSVG from '../../../img/icons/view_mode_hidden.svg?raw';
import ViewModeCollapsedSVG from '../../../img/icons/view_mode_collapsed.svg?raw';
import ViewModeOpenSVG from '../../../img/icons/view_mode_open.svg?raw';
import { ViewModeState } from '../../constants';
import './ViewModeToggle.scss';

/**
 * Segmented control for switching between view modes with icons
 */
export const ViewModeToggle = ({ value, onChange, disabled, className = '' }) => {
    const segmentedOptions = useMemo(
        () => [
            {
                label: <CustomSVG svg={ViewModeHiddenSVG} className="view-mode-icon" />,
                value: ViewModeState.HIDDEN,
            },
            {
                label: <CustomSVG svg={ViewModeCollapsedSVG} className="view-mode-icon" />,
                value: ViewModeState.COLLAPSED,
            },
            {
                label: <CustomSVG svg={ViewModeOpenSVG} className="view-mode-icon" />,
                value: ViewModeState.OPEN,
            },
        ],
        [],
    );

    return (
        <Segmented
            shape="round"
            options={segmentedOptions}
            value={value}
            onChange={onChange}
            disabled={disabled}
            className={`view-mode-toggle ${className}`}
        />
    );
};
